import { useState, useEffect } from "react";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import getRequestInterface from "utilFunctions/Axios/getRequestInterface";
import {
  BASE_URL,
  STUDENT_HTML_URL,
} from "utilFunctions/Constants/urlConstants";

interface SubjectHTML {
  subject: string;
  s3Url: string;
}

export const useStudentHTMLData = (psid?: string) => {
  const [data, setData] = useState<SubjectHTML[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    if (!psid) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const url = BASE_URL + STUDENT_HTML_URL + psid;
        await getAPIRequest({
          url,
          success: (response: any) => {
            const { data: res } = response || {};
            const { data } = res || {};
            setData(data || []);
          },
          failure: (err: any) => {
            setError(err);
            console.error("Failed to fetch student HTML:", err);
          },
        } as getRequestInterface);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [psid]);

  return { data, loading, error };
};
